import * as React from 'react'
import { EditRemoveMenu } from 'components/checkin-shared'
import { NotificationDraft } from './types'
import { notificationDetail } from './helpers'
import { NotificationToggle } from './notification-toggle'

// A single cadence rule row: enable toggle + name/detail, and (only when an edit
// handler is supplied) a kebab menu. `onRemove` is independently optional — pass
// it to offer Remove, or omit it for an edit-only menu (e.g. the Performance
// Cycle Default Settings page omits it for default reminders, since those can
// only be enabled/disabled there; a cycle's own copy stays fully removable).
export function NotificationCard({
  notification,
  onToggle,
  onEdit,
  onRemove,
}: {
  notification: NotificationDraft
  onToggle: () => void
  onEdit?: () => void
  onRemove?: () => void
}) {
  // The kebab shows whenever an edit handler is supplied. `onRemove` is optional:
  // seeded default reminders render an edit-only menu (they can be turned off but
  // not deleted), while custom reminders pass both and keep Remove.
  const hasMenu = Boolean(onEdit)

  return (
    <div className="flex items-center justify-between gap-4 rounded-lg border border-gray-200 bg-white px-5 py-4">
      <div className="flex items-center gap-4">
        <NotificationToggle
          enabled={notification.enabled}
          onChange={onToggle}
          label={`Toggle ${notification.name || 'notification'}`}
        />
        <div>
          <p className="m-0 font-talent text-base font-medium leading-5 text-indigo-950">
            {notification.name || 'Untitled notification'}
          </p>
          <p className="m-0 mt-1 font-talent text-sm font-normal leading-4 text-gray-500">
            {notificationDetail(notification)}
          </p>
        </div>
      </div>

      {hasMenu && onEdit && (
        <EditRemoveMenu
          triggerLabel={`Actions for ${notification.name || 'notification'}`}
          onEdit={onEdit}
          onRemove={onRemove}
        />
      )}
    </div>
  )
}
